// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preWarning {\n  position: relative;\n}\n.preWarning .actions {\n    position: absolute;\n    right: 0;\n    top: 3px;\n    z-index: 99;\n}\n.preWarning .actions span {\n      font-size: 14px;\n}\n.preWarning .actions i:before {\n      font-size: 16px;\n}\n.preWarning .tabSpanStyle {\n    font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
